
import { MapConfigBaseLayer } from "../app/core/models/mapping";
import { AppConfigBase } from "./app-config-base";

export class RypplzzAppConfig extends AppConfigBase {

  constructor() {
    super('RYPPLZZ')
    this.syncUrl = 'https://testbedrypplzz.furtherllc.com/db'
    this.apiUrl = 'https://testbedrypplzz.furtherllc.com/api'
    this.wsUrl = 'wss://testbedrypplzz.furtherllc.com/api/'
    this.graphQLUrl = 'https://testbedrypplzz.furtherllc.com/graphql'
    this.graphQLWsUrl = 'wss://testbedrypplzz.furtherllc.com/graphql'

    this.fileImport = {
      // import type is enabled if carrierIdRegex OR titleRegex matches
      carrierIdRegex: '^(rypplzz)$',
      titleRegex: '(?i)^(baro log|handsets|gps log|one source.*|antenna.*|lma call log|rypplzz location log)$'
    }

    this.mapConfig.baseLayers = [ MapConfigBaseLayer.OpenStreetLayer ]

    const participants = [
      {name:"rypplzz", title:"RYPPLZZ"}
    ];
    this.pathTest.participants = participants;
    this.driveTest.enabled = false;
    //this.driveTest.participants = participants;

    this.dialer.defaultProfile = {
      callCount: 2,
      callDurationSecs: 30,
      callWaitSecs: 2*60,
      callSetupTimeoutSecs: 15
    }
  }
}


export const AppConfig = new RypplzzAppConfig()
